import { Controller } from 'react-hook-form';
import { StanInput } from '@/components';
import { FlowStepProps } from '../../../types/addFlow.types';

export const FlowNameStep = ({ control, errors }: FlowStepProps) => {
    return (
        <div className='mb-6 flex w-full flex-col gap-6 sm:mb-8 sm:gap-8'>
            <h3>Give your flow a name</h3>
            <Controller
                name='flowName'
                control={control}
                render={({ field }) => (
                    <StanInput
                        {...field}
                        innerLabel='Flow Title'
                        placeholder='Name Your Flow'
                        error={!!errors.flowName}
                        hintText={errors.flowName?.message}
                    />
                )}
            />
        </div>
    );
};
